import PropertiesCardContentWrapper from './PropertiesCardContentWrapper';
import { withErrorBoundarySdk } from './withErrorBoundary';
// @ts-expect-error js module
import { universalEditableAreas } from 'customer-data-properties/savebar/EditableAreas';
import { useCallback, useMemo } from 'react';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import emptyFunction from 'react-utils/emptyFunction';
import { useCardRenderMarkers } from 'crm-cards-sdk/hooks/useCardRenderMarkers';
import CardContentLoadingComponent from 'crm-cards-sdk/components/skeletons/CardContentLoadingComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const DataProviderSdkWrapper = props => {
  const {
    cardId,
    editableAreasAtom,
    hasScope,
    isUngated,
    objectId,
    objectTypeId,
    propertyNames,
    readOnly,
    userPermission,
    propertySource
  } = props;
  const {
    SuccessMarker
  } = useCardRenderMarkers();
  const propertySourceInfo = useMemo(() => {
    return {
      propertySource
    };
  }, [propertySource]);
  const editableAreas = editableAreasAtom || universalEditableAreas;
  const sendUpdateObject = useSendCrmMessageTopic(TOPIC_NAMES.UPDATE_OBJECT);
  const sendShowPropertyHistory = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_PROPERTY_HISTORY);
  const onObjectUpdate = useCallback(({
    properties
  }) => {
    const updatedPropertyNames = Object.keys(properties);
    sendUpdateObject({
      objectTypeId,
      objectId: String(objectId),
      propertyNames: updatedPropertyNames
    });
  }, [sendUpdateObject, objectTypeId, objectId]);
  const onShowPropertyHistory = useCallback(({
    property
  }) => {
    sendShowPropertyHistory({
      objectTypeId,
      objectId: String(objectId),
      propertyNames: [property.name]
    });
  }, [sendShowPropertyHistory, objectTypeId, objectId]);
  return /*#__PURE__*/_jsx(PropertiesCardContentWrapper, {
    cardId: cardId,
    editableAreas: editableAreas,
    hasScope: hasScope,
    readOnly: readOnly,
    isEmbedded: false,
    isUngated: isUngated,
    objectId: objectId,
    objectTypeId: objectTypeId,
    onObjectUpdate: onObjectUpdate,
    onSaveSuccess: emptyFunction,
    onShowPropertyHistory: onShowPropertyHistory,
    propertyNames: propertyNames,
    propertySourceInfo: propertySourceInfo,
    SuccessMarker: SuccessMarker,
    userPermission: userPermission,
    CardContentLoadingComponent: CardContentLoadingComponent
  });
};
export default withErrorBoundarySdk(DataProviderSdkWrapper);